<template>
  <div>
    <a v-if="showMarquee()" @click="goToCampaign">
      <div class="marquee-container">
        <svg xmlns="http://www.w3.org/2000/svg" class="announcement-icon" version="1.0" viewBox="0 0 1280.000000 1079.000000" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,1079.000000) scale(0.100000,-0.100000)" stroke="none" fill="#fff">
            <path d="M7100 10730 c-36 -31 -528 -453 -1095 -936 -566 -483 -1351 -1152 -1742 -1486 l-713 -608 -1533 0 c-996 0 -1553 -4 -1588 -10 -193 -37 -379 -216 -419 -406 -7 -33 -10 -644 -8 -1899 3 -1773 4 -1852 22 -1899 46 -125 150 -243 265 -305 122 -65 23 -61 1698 -61 l1523 0 1253 -1067 c688 -587 1512 -1289 1829 -1560 318 -270 580 -488 583 -483 12 19 34 178 44 315 79 1045 89 5271 21 8665 -19 944 -49 1730 -68 1779 -6 16 -15 12 -72 -39z" />
            <path id="wave3" d="M10847 10100 c-98 -109 -177 -200 -177 -202 0 -2 55 -60 123 -129 270 -273 505 -616 726 -1059 652 -1311 890 -2979 640 -4485 -158 -954 -481 -1811 -992 -2631 -101 -163 -301 -452 -374 -540 l-33 -41 217 -163 217 -163 22 26 c42 49 242 332 336 477 229 351 419 700 583 1069 587 1325 789 2790 589 4281 -188 1410 -728 2714 -1455 3517 -61 68 -141 149 -178 182 l-68 60 -176 -199z" />
            <path id="wave2" d="M9730 8794 c-91 -102 -169 -191 -174 -197 -5 -9 18 -38 74 -92 720 -698 1123 -2299 965 -3835 -106 -1032 -455 -1890 -969 -2389 -42 -41 -75 -77 -74 -82 4 -11 349 -389 355 -389 14 0 118 99 205 195 679 749 1058 1944 1058 3335 0 1358 -368 2615 -984 3360 -85 103 -262 280 -279 279 -7 0 -86 -84 -177 -185z" />
            <path id="wave1" d="M8189 7733 l-196 -176 91 -107 c616 -722 838 -1675 627 -2691 -106 -507 -320 -1004 -627 -1456 l-83 -122 197 -139 c108 -76 208 -146 221 -155 29 -19 22 -26 138 148 374 562 624 1192 722 1815 39 251 46 343 46 635 0 295 -8 399 -46 633 -97 590 -347 1149 -716 1605 -83 103 -161 187 -171 187 -4 -1 -95 -80 -203 -177z" />
          </g>
        </svg>
        <div class="scrolling-text-wrapper">
          <span class="actual-scrolling-text">
            <strong v-if="currentCampaign.title">【{{ currentCampaign.title }}】</strong> {{ currentCampaign.content }}
          </span>
        </div>

        <button class="marquee-close-button" @click="closeMarquee">&times;</button>
      </div>
    </a>
    <!-- 廣告頁插頁 -->
    <transition name="fade">
      <div v-if="showCampaignPage" class="mask" />
    </transition>
    <transition name="slide">
      <div v-if="showCampaignPage" class="campaign-page-container">
        <iframe :src="currentCampaign.linkUrl" class="campaign-page" loading="lazy" />
        <button class="campaign-page-close-btn" @click="showCampaignPage = false">
          关闭
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/plugins/api'
import { removeQueryParam } from '@/utils/helper'
import { mapState } from 'vuex'

export default {
  name: 'DepositCampaignMarquee',
  data() {
    return {
      showPopup: false,
      currentCampaign: null,
      adPosition: '9',
      channel: 'DEPOSIT',
      showCampaignPage: false,
      localStorageKey: 'depositCampaignLinkUrl'
    }
  },
  computed: {
    ...mapState(['pageType', 'user'])
  },
  watch: {
    currentCampaign: function(newVal) {
      this.currentCampaign = newVal
      this.showPopup = !!newVal
    }
  },
  mounted() {
    this.queryForApp()
  },
  methods: {
    closeMarquee() {
      localStorage.setItem(this.localStorageKey, this.currentCampaign.linkUrl)
      this.currentCampaign = null
    },
    showMarquee() {
      return this.currentCampaign && (!new URLSearchParams(window.location.search).has('flavor') || (new URLSearchParams(window.location.search).has('flavor') && this.currentCampaign.flavor.split(',').includes(new URLSearchParams(window.location.search).get('flavor')))) && this.currentCampaign.linkUrl !== localStorage.getItem(this.localStorageKey)
    },
    queryForApp() {
      const data = {
        channel: this.channel
      }
      api.queryForAppH5(data).then(res => {
        if (res && res.data && res.data.code == 200 && res.data.ch_msg[this.adPosition]) {
          this.currentCampaign = res.data.ch_msg[this.adPosition].length > 0 ? res.data.ch_msg[this.adPosition][0] : null
        }
      })
    },
    goToCampaign() {
      if (!this.currentCampaign) {
        return
      }

      if (this.pageType == 'app') {
        this.showCampaignPage = true
        return
      }
      window.open(removeQueryParam(this.currentCampaign.linkUrl, 'noneheader'), '_blank')
    }
  }
}
</script>
<style>
.marquee-container {
    width: 6.5rem;
    background-image: linear-gradient(to right, #DAA520, #FFD700, #DAA520); /* Lighter gold gradient: GoldenRod, Gold, GoldenRod */
    color: #fff; /* Dark gray text color */
    margin: 0.3rem; /* Padding for the container itself */
    border-radius: 0.75rem; /* Rounded corners for the container */
    margin-bottom: 0;
    padding: 0.1rem 0.2rem;
    border-radius: 0.75rem; /* Rounded corners for the container */
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); /* Soft shadow */

    /* Flexbox to align icon and text wrapper */
    display: flex;
    align-items: center; /* Vertically center icon and text wrapper */
    overflow: hidden; /* Fallback clipping for the entire container */
    height: 0.3rem;
}

.announcement-icon {
    height: 0.3em; /* Icon size */
    width: 0.3em;
    margin-right: 0.1rem;
    flex-shrink: 0;
    transform-origin: center center;
    fill: currentColor; /* SVG paths will inherit this */
}

/* Style for the wave paths */
.announcement-icon #wave1,
.announcement-icon #wave2,
.announcement-icon #wave3 {
    opacity: 0; /* Start hidden */
}

.announcement-icon #wave1 {
    animation: animateWave1 3s infinite; /* Updated duration */
}
.announcement-icon #wave2 {
    animation: animateWave2 3s infinite; /* Updated duration */
}
.announcement-icon #wave3 {
    animation: animateWave3 3s infinite; /* Updated duration */
}

/* Keyframes for wave animations (3-second cycle) */
/* Wave 1 (innermost) */
@keyframes animateWave1 {
    0% { opacity: 0; }
    16.67% { opacity: 1; }   /* Appears (0s -> 0.5s) */
    75% { opacity: 1; }      /* Stays visible (until 2.25s) */
    91.67%, 100% { opacity: 0; } /* Disappears (2.25s -> 2.75s) and stays hidden */
}

/* Wave 2 (middle) */
@keyframes animateWave2 {
    0%, 16.67% { opacity: 0; } /* Hidden while wave1 appears */
    33.33% { opacity: 1; }   /* Appears (0.5s -> 1s) */
    75% { opacity: 1; }      /* Stays visible (until 2.25s) */
    91.67%, 100% { opacity: 0; } /* Disappears and stays hidden */
}

/* Wave 3 (outermost) */
@keyframes animateWave3 {
    0%, 33.33% { opacity: 0; } /* Hidden while wave1 & wave2 appear */
    50% { opacity: 1; }      /* Appears (1s -> 1.5s) */
    75% { opacity: 1; }      /* Stays visible (until 2.25s) */
    91.67%, 100% { opacity: 0; } /* Disappears and stays hidden */
}

.scrolling-text-wrapper {
    flex-grow: 1; /* Allows this wrapper to take up available horizontal space */
    overflow: hidden; /* Crucial: This will clip the animated text within its bounds */
    white-space: nowrap; /* Ensures the inner span doesn't wrap, essential for marquee */
    display: flex;
    /* Add a mask for fade-in (right) and fade-out (left) effects */
    -webkit-mask-image: linear-gradient(to right, transparent 0%, black 15%, black 85%, transparent 100%);
    mask-image: linear-gradient(to right, transparent 0%, black 15%, black 85%, transparent 100%);
    /* The gradient fades the text in from the right and out to the left */
}

.actual-scrolling-text {
    display: inline-block; /* Necessary for transform and padding-left to work as expected */
    padding-left: 100%; /* Start the text off-screen to the right of .scrolling-text-wrapper */

    /* Default animation properties */
    animation-name: marquee-animation-mobile;
    animation-duration: 20s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    font-size: 0.28rem; /* Text size (18px for default 16px root) */
}

.marquee-close-button {
    background-color: transparent; /* Removed background */
    color: #ffffff; /* White X */
    border: none;
    border-radius: 0.25rem; /* Slight rounding, can be 0 or 50% too */
    width: 0.75em; /* Match SVG icon height (relative to parent font-size) */
    height: 0.75em; /* Match SVG icon height (relative to parent font-size) */
    font-size: 0.3em; /* Make the X character larger, relative to parent font-size */
    text-align: center;
    cursor: pointer;
    padding: 0.35rem;
    margin-right: -0.2rem;
    z-index: 10;
    transition: color 0.2s ease; /* Transition for text color change */
    display: flex; /* For centering the X */
    align-items: center; /* For centering the X */
    justify-content: center; /* For centering the X */
}

/* Define specific animation keyframes for mobile */
@keyframes marquee-animation-mobile {
    0% {
        transform: translateX(0%); /* Start position */
    }
    100% {
        /* Example: Make it travel slightly further to ensure it's off-screen,
            or implement entirely different animation steps here. */
        transform: translateX(-105%); /* Slightly different end for mobile example */
    }
}

/* Define animation keyframes for the bell icon's new swing sequence: L -> R -> Middle -> Pause */
@keyframes bell-shake {
    0% { /* Start at Middle */
        transform: rotate(0deg);
    }
    15% { /* Swing Left */
        transform: rotate(-30deg) translateX(-1px); /* Increased swing degree */
    }
    30% { /* Swing Right */
        transform: rotate(30deg) translateX(1px); /* Increased swing degree */
    }
    45% { /* Swing to Middle */
        transform: rotate(0deg);
    }
    /* Pause at Middle from 45% to 100% */
    100% {
        transform: rotate(0deg);
    }
}

.mask {
  /* Make sure the mask covers the entire viewport */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* Use a dark gray color with opacity for the mask effect */
  background-color: rgba(0, 0, 0, 0.5); /* RGBA for color and opacity */

  /* Ensure the mask is behind other elements (like the popup) */
  z-index: 10; /* You can adjust the z-index as needed */
  display: flex; /* Added for centering the popup */
  align-items: center;
  justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease; /* Define the transition for opacity */
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0; /* Start with 0 opacity (fade out) */
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.campaign-page-container {
    z-index: 999999;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    height: 97.5vh;
    width: 100%;
    top: 0;
}

iframe.campaign-page {
    width: 95%;
    height: 100%;
    margin-left: 2.5%;
    margin-top: 2.5%;
}

button.campaign-page-close-btn {
    position: absolute;
    right: 0rem;
    top: 0.35rem;
    margin-right: 0.3rem;
    height: 0.75rem;
    width: 1.4rem;
    border-radius: 0.1rem;
    border: 0;
    font-size: 0.25rem;
    color: #ffff;
    background: #444;
    line-height: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  overflow: hidden;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100%); /* Start below the viewport */
}

.slide-enter-to,
.slide-leave-from {
  transform: translateY(0);
}
  </style>
